import { render, staticRenderFns } from "./MintNftWizard.vue?vue&type=template&id=fcb2ede2&"
import script from "./MintNftWizard.vue?vue&type=script&lang=js&"
export * from "./MintNftWizard.vue?vue&type=script&lang=js&"
import style0 from "./MintNftWizard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports